













import echarts from 'echarts'
import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'MiniChart'
})
export default class extends Vue {
  @Prop({ required: true }) type!: string
  @Prop({ required: true }) title!: string
  @Prop({ required: true }) number!: number | string
  @Prop({ required: true }) trend!: string
  @Prop({ required: false }) borderColor!: string

  tableData: any[] = [
    {
      count: 20,
      date: 9.1
    },
    {
      count: 50,
      date: 9.2
    },
    {
      count: 34,
      date: 9.3
    },
    {
      count: 20,
      date: 9.4
    },
    {
      count: 56,
      date: 9.5
    },
    {
      count: 36,
      date: 9.6
    },
    {
      count: 11,
      date: 9.7
    },
    {
      count: 99,
      date: 9.8
    },
    {
      count: 43,
      date: 9.9
    }
  ]

  // computed
  get chartColor() {
    return this.type === 'line' ? '#fb6260' : '#0099ff'
  }

  // mounted

  // methods
  drawChart() {
    let myChart = echarts.init(this.$refs.chart as any)
    let option: any = {
      xAxis: {
        data: this.tableData.map(item => item.date),
        boundaryGap: false,
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        show: false
      },
      // y轴没有显式设置，根据值自动生成y轴
      yAxis: {
        type: 'value',
        min: 0,
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: { formatter: '{value}' },
        show: false
      },
      // 数据-data是最终要显示的数据
      series: [
        {
          type: this.type,
          data: this.tableData.map(item => item.count),
          itemStyle: {
            normal: {
              color: this.chartColor, // 折线点的颜色
              lineStyle: {
                color: this.chartColor // 折线的颜色
              }
            }
          },
          symbol: 'circle'
        }
      ]
    }
    myChart.setOption(option)
  }
}
